import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { BetterDocButton } from "@/modules/patients/detail/better-doc/components/better-doc-button"
import { isBetterDocOffered } from "@/modules/patients/detail/better-doc/lib/is-better-doc-offered"
import { isBetterDocRequired } from "@/modules/patients/detail/better-doc/lib/is-better-doc-required"
import { usePointOfCareBetterDocContext } from "@/modules/patients/detail/better-doc/point-of-care-better-doc-context"

export const BetterDocSection = () => {
  const { t } = useTranslation()
  const { betterDocUsage } = usePointOfCareBetterDocContext()
  if (!isBetterDocOffered(betterDocUsage)) {
    return null
  }

  return (
    <div className="mt-4 flex items-center gap-2">
      {(betterDocUsage === "ALLOWED" || betterDocUsage === "CONDITION_PACKAGE") && (
        <Banner type="inline" variant="warning" data-testid="better-doc-allowed-banner">
          {t("episodeOfCare.progressNote.pointOfCare.betterDocAllowed")}
        </Banner>
      )}

      {isBetterDocRequired(betterDocUsage) && (
        <Banner type="inline" variant="critical" data-testid="better-doc-required-banner">
          {t("episodeOfCare.progressNote.pointOfCare.betterDocRequired")}
        </Banner>
      )}

      <BetterDocButton />
    </div>
  )
}
